
export class Float32Matrix2D {

    public readonly width: number;
    public readonly height: number;
    public readonly data: Float32Array<ArrayBuffer>;

    constructor(width: number, height: number) {
        this.width = width;
        this.height = height;
        this.data = new Float32Array(width * height);
    }

    public set(x: number, y: number, value: number) {
        const i = this.index(x, y);
        this.data[i] = value;
    }

    public get(x: number, y: number): number {
        const i = this.index(x, y);
        return this.data[i];
    }

    public at(index: number): [number, number] {
        const x = index % this.width;
        const y = ~~(index / this.width);
        return [x, y];
    }

    public index(x: number, y: number): number {
        const index = y * this.width + x;
        return index;
    }

    public has(x: number, y: number): boolean {
        return x >= 0 && y >= 0 && x < this.width && y < this.height;
    }
}
